export default class DonationContactText {
    static fromApi(response) {
        var _a, _b, _c;
        const data = (_a = response === null || response === void 0 ? void 0 : response.translations) === null || _a === void 0 ? void 0 : _a.pop();
        const contactText = new DonationContactText();
        contactText.email = (_b = data === null || data === void 0 ? void 0 : data.email) !== null && _b !== void 0 ? _b : '';
        contactText.text = (_c = data === null || data === void 0 ? void 0 : data.donation_text) !== null && _c !== void 0 ? _c : '';
        return contactText;
    }
}
